import { Pipe, PipeTransform } from '@angular/core';
import { EnumService } from '@valg-shared/services/enums/enum.service';

@Pipe({
  name: 'enumTranslation',
})
export class EnumTranslationPipe implements PipeTransform {
  constructor(private readonly enumService: EnumService) {}

  transform(value?: string, enumName?: string): unknown {
    return this.enumService.translateValue(value, enumName);
  }
}